// The invite token from a refer & earn link (LP-998). The landing's /r/<token> sends people to /signup?ref=<token>;
// the token waits in this tab until the code is verified, then goes once as `ref` on POST /auth/otp/verify.
const KEY = 'lp.ref'
const TOKEN = /^[A-Za-z0-9_-]{8,64}$/

/** Keeps `?ref=` from a URL search, if it holds a plausible token. Storage can be blocked: then nothing is kept. */
export function captureRef(search: string): void {
  const ref = new URLSearchParams(search).get('ref')?.trim()
  if (!ref || !TOKEN.test(ref)) return
  try {
    sessionStorage.setItem(KEY, ref)
  } catch {
    /* storage blocked */
  }
}

export function readRef(): string | undefined {
  try {
    return sessionStorage.getItem(KEY) ?? undefined
  } catch {
    return undefined
  }
}

export function clearRef(): void {
  try {
    sessionStorage.removeItem(KEY)
  } catch {
    /* storage blocked */
  }
}

/** The search without `ref`, so it isn't carried into the login URL once kept. */
export function withoutRef(search: string): string {
  const params = new URLSearchParams(search)
  params.delete('ref')
  const rest = params.toString()
  return rest ? `?${rest}` : ''
}
